import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const LinkContent = styled.div`
    label: LinkContent;

    flex: 1;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0 auto 70px auto;

    color: #262626;
    display: inline-block;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    font-family: effra, he Helvetica, Arial, sans-serif;
    a {
        color: #0098db;
        text-decoration: none;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }
`;
const Link = ({ dataQa, label, url }) => (
    <LinkContent data-qa={dataQa}>
        <a href={url} target="_blank" rel="noopener noreferrer">
            {label}
        </a>
    </LinkContent>
);

export const LinkPropTypes = {
    dataQa: PropTypes.string,
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};
Link.propTypes = LinkPropTypes;
Link.defaultProps = {};
export default Link;
